import { makeStyles } from "@mui/styles";
import tinycolor from "tinycolor2";
const lightenRate = 45;

export default makeStyles((theme) => ({
  cardcount: {
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexGrow: 1,
    minWidth: 200,
    minHeight: 96,
    backgroundColor: "white",
    borderRadius: 8,
    padding: "16px 24px",
    border: "1px solid transparent",
    "&:hover": {
      backgroundColor: tinycolor(theme.palette.primary.main)
        .lighten(lightenRate)
        .toHexString(),
      border: `1px solid ${theme.palette.primary.main}`
    }
  },
  left: {
    textAlign: "left"
  },
  title: {
    fontSize: 16,
    fontWeight: 400,
    color: "#475367",
    letterSpacing: -0.5,
    marginBottom: 0,
    marginTop: 0
  },
  count: {
    fontSize: 24,
    fontWeight: 500,
    marginBottom: 0,
    marginTop: 8,
    color: "#344054"
  },
  icon: {
    border: "1px solid #E4E7EC",
    width: 40,
    height: 40,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center"
  },
  skeleton: {
    display: "inline-block",
    width: 40,
    height: 20,
    borderRadius: 4,
    backgroundColor: "#E4E7EC",
    animation: "$pulse 1.5s ease-in-out infinite"
  },
  "@keyframes pulse": {
    "0%": { opacity: 1 },
    "50%": { opacity: 0.4 },
    "100%": { opacity: 1 }
  }
}));
